import React from "react";
import FlipCard from "../../utility/FlipCard";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useTranslation } from 'react-i18next';
import { fadeInUp, staggerContainer, staggerItem, hoverScale } from "../../utility/framerAnimations";
import "./LendingPartnerSection.css";
import { TRUSTPAISA_URL, DWINGER_AGENTS_URL, FI_URL } from "../../Constants";

function LendingPartnerSection() {
  const { t } = useTranslation(['lenderPage', 'homepage']);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (

    <div className="lending-partner-section">
      {/* Background gradient container */}
      <div className="lending-partner-section-gradient-background" />

      {/* Content container */}
      <motion.div
        ref={ref}
        className="lending-partner-section-content-container"
        variants={staggerContainer}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        <motion.div
          className="lending-partner-section-header"
          variants={fadeInUp}
        >
          <h2 className="lending-partner-section-title">
            {t('lending-partner-section-title')}
          </h2>
        </motion.div>

        {/* Partners grid */}
        <motion.div
          className="lending-partner-section-grid"
          variants={staggerItem}
        >
          {/* FlipCard functionality commented out - replaced with simple image redirect */}
          {/* <FlipCard
            coverImage="/images/trust-paisa-logo-1.png"
            name={"TrustPaisa"}
            url={TRUSTPAISA_URL}
            grievanceURL={TRUSTPAISA_URL}
            pp={TRUSTPAISA_URL}
            tc={TRUSTPAISA_URL}
          /> */}

          {/* Simple partner image with click redirect */}
          <div className="lending-partner-section-card">
            <div className="lending-partner-section-front">
              <img
                src="/images/trust-paisa-logo-1.png"
                alt="TrustPaisa Logo"
                className="lending-partner-section-logo"
                onClick={() => window.open(TRUSTPAISA_URL, '_blank')}
                style={{ cursor: 'pointer' }}
              />
            </div>
          </div>

          {/* Cashe partner card with flip functionality */}
          <FlipCard
            coverImage="/images/cashe.png"
            name={"Cashe"}
            url={"mailto:Grievance@bhanix.in"}
            grievanceURL={"mailto:Grievance@bhanix.in"}
            pp={"/documents/Terms-Conditions-For-Loan.pdf"}
            tc={"/documents/Terms-Conditions-For-Loan.pdf"}
          />

          {/* Fi partner card */}
          <div className="lending-partner-section-card">
            <div className="lending-partner-section-front">
              <img
                src="/images/fi.png"
                alt="Fi Logo"
                className="lending-partner-section-logo fi-logo"
                onClick={() => window.open(FI_URL, '_blank')}
                style={{ cursor: 'pointer', border: 'none', outline: 'none' }}
              />
            </div>
          </div>

          {/* Dwinger Agents partner card */}
          <div className="lending-partner-section-card">
            <div className="lending-partner-section-front">
              <img
                src="/images/dwinger-agents-logo.png"
                alt="Dwinger Agents Logo"
                className="lending-partner-section-logo"
                onClick={() => window.open(DWINGER_AGENTS_URL, '_blank')}
                style={{ cursor: 'pointer', border: 'none', outline: 'none' }}
              />
            </div>
          </div>
        </motion.div>

        {/* Personal Loan CTA Section */}
        <motion.div className="personal-loan-cta-section"
          variants={fadeInUp}
        >
          <h1 className="homepage-hero-title">
            <span className="homepage-hero-title-primary">{t('homepage:hero-title-primary')}</span>
            <span className="homepage-hero-title-highlight">{t('homepage:hero-title-highlight')}</span>
          </h1>
          <button
            className="btn btn-primary"
            variants={hoverScale}
            whileHover="hover"
            whileTap={{ scale: 1.2 }}
            onClick={() => window.location.href = '/'}
          >
            {t('homepage:hero-start-application')}
          </button>
        </motion.div>
      </motion.div>

    </div>

  );
}

export default LendingPartnerSection;
